// Docs settings are stored separately to Cinnamon preferences so that preference examples don't interfere
const key = `${process.env.COOKIE_PREFIX}-settings`;

export const getDefaultSettings = () => ({
  apiBeforeExamples: false,
  darkMode: false,
});

export const loadSettings = () => {
  const rawValue = localStorage.getItem(key);
  return rawValue ? JSON.parse(rawValue) : getDefaultSettings();
};

export const saveSettings = (value) => {
  const rawValue = JSON.stringify(value);
  localStorage.setItem(key, rawValue);
};
